import { isEmpty } from 'lodash'

import createComputed from 'modules/core/hooks/createComputed'
import { matchText } from 'modules/core/lib/stringUtils'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import employees from 'modules/employees/store/collections/employees'
import getUserByItem from 'modules/payroll_bundle/components/common/helper/getUserByItem'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

export const useSearchFilter = createComputed((search: string, items: PaymentItem[]) => {
  if (isEmpty(search)) return items

  return items.filter((item) => {
    const user = getUserByItem(item)

    const employee = employees.get(item.attributes.employee_id)

    return (
      (item.has('full_name') && matchText(search, item.attributes.full_name)) ||
      (user &&
        matchText(
          search,
          getFullDisplayName({
            firstName: user.attributes.first_name,
            lastName: user.attributes.last_name,
            canSharePreferredName: employee?.policy.can('sharePreferredName'),
            preferredName: employee?.attributes.preferred_name,
          })
        ))
    )
  })
})
